import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { ClienteTipoMultiselectComponent } from './cliente-tipo-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        ClienteTipoMultiselectComponent
    ],
    exports: [
        ClienteTipoMultiselectComponent
    ]
})
export class ClienteTipoMultiselectModule { }
